/**
 * Onde a API mora, e como o cookie de sessao chega ate ela.
 *
 * Os quatro `api.ts` do sistema tinham, cada um, a mesma linha `const BASE =
 * '/api'`. Ela era verdadeira enquanto a tela e a API dividiam a mesma origem
 * e o proxy do Vite tirava o prefixo. A partir da implantacao em containers
 * elas moram em MAQUINAS diferentes (ver ADR-005, "Empacotamento e
 * implantacao"), e o endereco passou a ser coisa de ambiente.
 *
 * ## O endereco NAO esta escrito aqui, e nao vai estar
 *
 * O dono foi explicito: *"por enquanto o dominio e esse mas nao eternamente"*.
 * Entao nenhum nome de maquina aparece neste arquivo — nem como padrao, nem
 * como exemplo em comentario. O doctor varre `src/` atras de dominio escrito a
 * mao e REPROVA se achar (bloco H12).
 *
 * ## A armadilha que custa uma tarde: `VITE_` e ASSADA NO BUILD
 *
 * `import.meta.env.VITE_API_URL` **nao e lida quando o sistema roda**. O Vite a
 * substitui pelo valor literal durante `vite build`, e o que vai para dentro da
 * imagem e o texto ja trocado. Consequencia pratica, e ela vale ouro:
 *
 *   mudar a variavel no painel e reiniciar o container NAO muda nada.
 *
 * Cada ambiente precisa CONSTRUIR a propria imagem, com a variavel presente no
 * momento do build — por isso ela e `ARG` no `docker/frontend.Dockerfile`, e
 * nao `ENV` na hora de subir. O runbook (`runbooks/deploy.md`) repete isso no
 * lugar onde o erro acontece.
 *
 * ## Vazio quer dizer "use o proxy"
 *
 * Sem `VITE_API_URL`, a base e `/api` e tudo segue como antes: o proxy do Vite
 * reescreve para o Fastify e tira o prefixo. E o caminho de desenvolvimento, e
 * ele continua funcionando sem nenhuma variavel posta.
 */

/**
 * A base de toda chamada a API, sem barra no fim.
 *
 * - vazio  -> `/api`, que o proxy do Vite reescreve (desenvolvimento)
 * - posto  -> o endereco completo da API deste ambiente (container)
 */
export const BASE_DA_API: string = (import.meta.env.VITE_API_URL ?? '').trim().replace(/\/+$/, '') || '/api';

/**
 * `'include'`, e nao `'same-origin'`.
 *
 * O token de sessao e um cookie `HttpOnly`: nenhum JavaScript desta pagina o
 * le, e por isso nenhuma tela pode "mandar o token" por conta propria — quem o
 * anexa e o navegador, e so se a chamada pedir. Enquanto a API dividia a
 * origem com a tela, `'same-origin'` bastava; com a API noutra maquina ele
 * omite o cookie em silencio, e TODA rota de dominio passa a responder 401 sem
 * que nada no servidor pareca errado.
 *
 * `'include'` faz o mesmo que `'same-origin'` quando a origem e a mesma, entao
 * nao ha perda no caminho de desenvolvimento. Do outro lado, ele exige que a
 * resposta traga `Access-Control-Allow-Credentials: true` e uma origem exata
 * (nunca `*`) — e e por isso que `CORS_ORIGENS` existe no backend.
 */
export const CREDENCIAIS_DA_API: RequestCredentials = 'include';
